import request from '../../util/request'
import formUtils from '../../util/formUtils'
import alertUtils from '../../util/alertUtils'
import { config } from '../../config/config'

/**
 * 生成代码 所涉及api
 */
export default class generateApi {
  /**
   *  根据字典类型查询字典项
   * @param  typeCode
   */
  static getDicList(typeCode) {
    if (formUtils.isNull(typeCode)) {
      alertUtils.alertWarning('查询字典列表字典类型代码不能为空', true)
      return
    }
    return request({
      url:
        config.baseAPI +
        '/v1/dictionary/getDictionaryValue?type_code=' +
        typeCode,
      method: 'get',
    })
  }

  /**
   *  获取地区数据
   *
   */
  static getAddressOptions() {
    return request({
      url: config.baseAPI + '/v1/area/selectAreaList',
      method: 'get',
    })
  }

  /**
   * 自定义接口
   * @param params
   */
  static getCustomService(url, params) {
    if (formUtils.isNull(url)) {
      alertUtils.alertWarning('url不能为空', true)
      return
    }
    return request({
      url:
        url.toUpperCase().indexOf('HTTP') !== -1 ? url : config.baseAPI + url,
      method: 'get',
      params,
    })
  }
}
